import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdditionalOwnerInvitesService {
  constructor(
    private http: ApiHttpClient
  ) { }

  resendAdditionalOwnerInvites(borrowerId: number): Observable<void> {
    return this.http.post<void>(`${environment.API_URL}/borrower/${borrowerId}/additional-owner-invites`, {});
  }

  resendAdditionalOwnerPostOfferVerification(borrowerId: number): Observable<void> {
    return this.http.post<void>(`${environment.API_URL}/borrower/${borrowerId}/additional-owner-post-offer-invites`, {});
  }
}
